module.exports = __webpack_public_path__ + "assets/successNote2Sheen-6a968c.svg";